import * as React from 'react';
import { Alert, Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { CognitoUser } from './lib/CognitoUser';

interface ILoginContainerState {
  username: string
  password: string
  requiresNewPassword: boolean
  newPassword: string
  newPasswordConfirm: string
  error?: string;
  submitting: boolean;
  cognitoUserNotFoundException: boolean
}

export class LoginContainer extends React.Component<{}, ILoginContainerState> {
  state: ILoginContainerState = {
    username: '',
    password: '',
    requiresNewPassword: false,
    newPassword: '',
    newPasswordConfirm: '',
    submitting: false,
    cognitoUserNotFoundException: false
  }

  cognitoUser: CognitoUser

  updateUser() {
    //todo
    //this.updateUserCredentials(this.cognitoUser);

    this.setState({ submitting: false, cognitoUserNotFoundException: false });
  }

  formLogin(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const { username, password } = this.state;
    this.cognitoUser = new CognitoUser(username)

    this.setState({ error: undefined, submitting: true })

    this.cognitoUser.login(password)
      .then(() => this.updateUser())
      .catch((err) => this.handleError(err))
  }

  createNewPassword(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const { newPassword, newPasswordConfirm } = this.state;

    if (newPassword !== newPasswordConfirm) {
      this.setState({ error: 'Passwords do not match.' })
      return
    }

    this.setState({ error: undefined, submitting: true });

    this.cognitoUser.completeNewPasswordChallenge(newPassword)
      .then(() => this.updateUser())
      .catch((err) => this.handleError(err))
  }

  handleError(err: any) {
    let error = String(err)
    console.log(err);
    if (CognitoUser.isNewPasswordRequiredError(err)) {
      this.setState({ requiresNewPassword: true, submitting: false })

      return;
    }

    //console.log(err)

    if (err.code === 'UserNotFoundException') {
      error = 'Due to security reasons, your account has been locked. Please contact techsupport@avannis.com for further assistance.';
      this.setState({ cognitoUserNotFoundException: true });
    } else if ('message' in err) {
      error = err.message;
    }

    this.setState({ error, submitting: false })
  }

  renderPasswordUpdate() {
    return (
      <section>
        <Alert color="info">Your password has expired. Create a new password to login.</Alert>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>New Password</Label>
              <Input type="text"
                onChange={(e) => this.setState({ newPassword: e.currentTarget.value })}
                value={this.state.newPassword} />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Confirm New Password</Label>
              <Input type="password"
                onChange={(e) => this.setState({ newPasswordConfirm: e.currentTarget.value })}
                value={this.state.newPasswordConfirm} />
            </FormGroup>
          </Col>
        </Row>
      </section>
    )
  }

  renderLogin() {
    return (
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Username</Label>
            <Input type="text" name="frmuser"
              onChange={(e) => this.setState({ username: e.currentTarget.value })}
              value={this.state.username} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Password</Label>
            <Input type="password" name="frmpswd"
              onChange={(e) => this.setState({ password: e.currentTarget.value })}
              value={this.state.password} />
          </FormGroup>
        </Col>
      </Row>
    )
  }

  render() {
    const { cognitoUserNotFoundException } = this.state;
    return (
      <section className="blacklight">
        <Form className="card-body" onSubmit={(e) => this.formLogin(e)}>
          {this.state.requiresNewPassword &&
            this.renderPasswordUpdate()
          }

          {!this.state.requiresNewPassword &&
            this.renderLogin()
          }

          {this.state.error &&
            <Alert color="destructive">
              <section>
                {this.state.error}
              </section>
              {cognitoUserNotFoundException &&
                <section>
                  If you are unaware of who your institution’s admin is, <span className="link" onClick={() => { window.dispatchEvent(new CustomEvent('updateIsModalOpen', { detail: true })); }}>ask for support</span>.
                </section>
              }
            </Alert>
          }

          <FormGroup className="d-flex justify-content-start">
            <Button color="primary" disabled={this.state.submitting} style={{ height: 'auto' }}>
              {this.state.submitting ?
                <>
                  <span>Submitting...&nbsp;</span>
                  <i className="fas fa-fw fa-cog fa-spin" />
                </>
                :
                <>
                  <span>Submit&nbsp;</span>
                  <i className="fas fa-fw fa-paper-plane" />
                </>
              }
            </Button>
          </FormGroup>
        </Form>
        <p>
          <a href="/forgotpassword" className="ml-4 align-self-center">Forgot Your Password?</a>&nbsp;
          or&nbsp;
          <a href="/forgotusername" className="align-self-center">Forgot Your Username?</a>
        </p>
      </section>
    );
  }
}
